import { COLOR_TEXT_PRIMARY } from '@alltrails/denali/tokens';
import { createCircleMarker } from './svgMarkerComponents';

const trailClusterSvg = createCircleMarker({ imageName: 'trail-cluster', innerDiameter: 24, innerFill: COLOR_TEXT_PRIMARY });

export default trailClusterSvg;
